import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  users: [],
  user: JSON.parse(localStorage.getItem('user'))
};

export default {
  state,
  getters,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/user/index.js